import { render, staticRenderFns } from "./CiBadge.vue?vue&type=template&id=76f5541d&"
var script = {}
import style0 from "./CiBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports